import { FC, memo } from 'react';
import { Button, Typography } from 'antd';
import { Link } from 'react-router-dom';

import { useTranslate } from 'hooks';

import { ReactComponent as SuccessReset } from 'assets/icons/success-reset.svg';

import s from './index.module.scss';

const ForgotPasswordUpdated: FC = memo(() => {
	const { loginText, passwordUpdatedText, passwordUpdateSuccessfullyText } = useTranslate([
		'loginText',
		'passwordUpdatedText',
		'passwordUpdateSuccessfullyText',
	]);

	return (
		<>
			<SuccessReset className={s.icon} />
			<Typography.Title level={4}>{passwordUpdatedText}</Typography.Title>
			<Typography.Text>{passwordUpdateSuccessfullyText}</Typography.Text>
			<Button type="primary" className={s.finishButton}>
				<Link to="/">{loginText}</Link>
			</Button>
		</>
	);
});

export { ForgotPasswordUpdated };
